import { useCategories } from '@/hooks/useServices'
import { useSelectServices } from '@/hooks/useServices'
import { useState } from 'react'
import Button from '@/components/common/Button/Button'
import './ProviderSelectServices.css'

const ProviderSelectServices = () => {
    const { data: categories, isLoading } = useCategories()
    const select = useSelectServices()
    const [selected, setSelected] = useState<number[]>([])

    const toggle = (id: number) => {
        setSelected((prev) => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])
    }

    const handleSave = async () => {
        if (!selected.length) return
        await select.mutateAsync({ 
            services: selected.map(serviceId => ({ service_id: serviceId }))
        })
    }

    return (
        <div className="provider-select-services-page">
            <div className="provider-select-services-container">
                <h1 className="provider-select-services-title">Seleccionar Servicios</h1>
            {isLoading ? (
                <div>Loading...</div>
            ) : (
                <div className="provider-selectservices_list">
                    {(categories || []).map((c: any) => (
                        <label key={c.id} className="provider-selectservices_item">
                            <input type="checkbox" checked={selected.includes(c.id)} onChange={() => toggle(c.id)} />
                            <span>{c.name}</span>
                        </label>
                    ))}
                </div>
            )}
                <Button variant="primary" onClick={handleSave} disabled={select.isPending || selected.length === 0} effect3d={false}>Guardar</Button>
            </div>
        </div>
    )
}

export default ProviderSelectServices


